import _slicedToArray from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import CartesianLabelManager from './cartesian-label-manager';
import { BLANKSTRING, extend2, parseUnsafeString, extent } from '../lib';
import range from './utils/array/range';
import LinearScale from './scales/linear';
import { setDataLimit, extractStyleInfo } from './common-api';
import domainUpdater from './domain-updater';
var UNDEF;

var NumericAxis =
/*#__PURE__*/
function (_CartesianLabelManage) {
  _inherits(NumericAxis, _CartesianLabelManage);

  function NumericAxis() {
    var _this;

    _classCallCheck(this, NumericAxis);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumericAxis).call(this)), _this.config.scale = new LinearScale();
    return _this;
  }

  _createClass(NumericAxis, [{
    key: "getName",
    value: function getName() {
      return 'numeric';
    }
  }, {
    key: "generateTicks",
    value: function generateTicks() {
      var a = Math.abs;

      var b,
          c,
          d,
          e = this.getScale(),
          f = this.config,
          g = f.numDivLines + 1,
          _e$getDomain = e.getDomain(),
          _e$getDomain2 = _slicedToArray(_e$getDomain, 2),
          h = _e$getDomain2[0],
          i = _e$getDomain2[1],
          j = f.axisRange,
          k = j.min,
          l = j.max,
          m = f.dataLimit;

      return h === k && i === l ? (domainUpdater(m.min, m.max, e, f), f.ticks) : (b = e.ticks(g), c = a(b[1] - b[0]), h === k && -1 === b.indexOf(k) && b.unshift(k), i === l && -1 === b.indexOf(l) && b.push(l), (d = a(k % c)) && (k -= d), (d = a(l % c)) && (l -= d), f._allTicks = range(k, l, c).concat(l), j.tickInterval = c, b);
    }
  }, {
    key: "setTickValues",
    value: function setTickValues(a) {
      this.config.userTicks = a || [], this.config.tickValues = {
        tickValue: []
      };
    }
  }, {
    key: "_parseTickValues",
    value: function _parseTickValues(a) {
      var b,
          c,
          d,
          e,
          f = this,
          g = f.getFromEnv('chart'),
          h = f.config,
          i = a && a.length,
          j = 0;

      for (h.tickValues = {}, b = h.tickValues.tickValue = [], d = 0; d < i; d += 1) {
        if (c = extend2({}, a[d]), e = +c.x, !c.vline) {
          if (extractStyleInfo(c, g), e || 0 === e) c.x = e, h.irregularCatAxis = !0;else continue;
          b.push(c), b[j].label = parseUnsafeString(b[j].label), j += 1;
        }
      }

      h.oriCatLen = j;
    }
  }, {
    key: "calculateTicksOnLabelMode",
    value: function calculateTicksOnLabelMode() {
      var a,
          b,
          c,
          d,
          e,
          f,
          g,
          h = this,
          k = h.config,
          l = k.xAxisLabelMode,
          m = Object.assign([], k.userTicks),
          n = h.getFromEnv('number-formatter');

      if ('mixed' === l || 'auto' === l) {
        if (b = [], a = n.xAxis, 'mixed' === l) for (c = 0, e = m.length; c < e; c += 1) {
          b[m[c].x || m[c].y || c] = !0;
        } else m = [];

        for (g = h.getAxisConfig(), f = k.ticks, d = 0; d < f.length; ++d) {
          c = f[d], b[c] || m.push({
            label: BLANKSTRING + a.call(n, c),
            x: c,
            showverticalline: 0 === c ? g.showZeroPlane : 1,
            isNumeric: !0,
            linecolor: 0 === c ? g.zeroPlaneColor : g.divLineColor,
            linealpha: 0 === c ? g.zeroPlaneAlpha : g.divLineAlpha,
            linethickness: 0 === c ? g.zeroPlaneThickness : g.divLineThickness,
            linedashed: g.divLineIsDashed,
            linedashLen: g.divLineDashLen,
            linedashgap: g.divLineDashGap
          });
        }
      }

      h._parseTickValues(m);
    }
  }, {
    key: "getInterval",
    value: function getInterval() {
      return this.config.axisRange.tickInterval;
    }
  }, {
    key: "_setAxisRange",
    value: function _setAxisRange(a) {
      var b,
          c,
          d,
          e = a.min,
          f = a.max,
          g = this.config,
          h = g.axisRange,
          i = g.dataLimit,
          j = g.dependentInfo;
      if (!(e > f)) if ((i.min !== e || i.max !== f) && (c = !0), g.visibleMin !== UNDEF && !g.setPadding && !c) g.setPadding = !1;else {
        var _extent, _extent2;

        if ((_extent = extent([e, f, i.min, i.max]), _extent2 = _slicedToArray(_extent, 2), e = _extent2[0], f = _extent2[1], _extent), i.min = e, i.max = f, this.fireEvent('dataLimitSet', Object.assign({}, i)), j) {
          var _extent3, _extent4;

          if (j.limit) if (b = j.dataLimit, b) (_extent3 = extent([e, f, b.min, b.max]), _extent4 = _slicedToArray(_extent3, 2), e = _extent4[0], f = _extent4[1], _extent3), g.isDataLimitSet = !0;else return;
          if (j.count && j.numDivLines === UNDEF) return;
        }

        domainUpdater(e, f, this.getScale(), g), d = g.isZeroTickForced ? 3 : 2, this.fireEvent('divlinesSet', g.ticks.length - d), g.tickValues && this.calculateTicksOnLabelMode(), this.setVisibleConfig(h.min, h.max);
      }
    }
  }]);

  return NumericAxis;
}(CartesianLabelManager);

NumericAxis.prototype.setDataLimit = setDataLimit;
export default NumericAxis;